import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const ref = params.get("reference") || params.get("trxref");
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    if (!ref) { setStatus("failed"); return; }
    api.get(`/subscription/verify/${ref}`).then(({ data }) => {
      setStatus(data.status === "success" ? "success" : "failed");
    }).catch(() => setStatus("failed"));
  }, [ref]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6" data-testid="payment-callback-page">
      <div className="card-surface p-10 max-w-md text-center">
        {status === "verifying" && (
          <>
            <div className="h-10 w-10 rounded-full border-2 border-[#E65F2B] border-t-transparent animate-spin mx-auto mb-4" />
            <h1 className="font-display text-2xl font-bold">Verifying your payment...</h1>
            <p className="text-sm text-white/50 mt-2">Hang tight, this takes just a moment.</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 className="h-14 w-14 text-green-400 mx-auto mb-4" />
            <h1 className="font-display text-3xl font-black">Welcome aboard!</h1>
            <p className="text-white/60 mt-2">Your subscription is active. The library is yours.</p>
            <Link to="/browse" className="ember-btn mt-6 inline-flex" data-testid="payment-success-cta">Start watching</Link>
          </>
        )}
        {status === "failed" && (
          <>
            <XCircle className="h-14 w-14 text-red-400 mx-auto mb-4" />
            <h1 className="font-display text-3xl font-black">Payment incomplete</h1>
            <p className="text-white/60 mt-2">Something went wrong. No charge has been confirmed.</p>
            <Link to="/subscription" className="ember-btn mt-6 inline-flex" data-testid="payment-retry-cta">Try again</Link>
          </>
        )}
      </div>
    </div>
  );
}
